<template>
	<div 
		class="c-breadcrumbs" 
		itemscope="itemscope" 
		itemtype="http://schema.org/BreadcrumbList" 
		role="navigation" 
		aria-labelledby="breadcrumbs-<?php echo $id = uniqid('id') ?>">
		<strong 
			v-if="isLabelVisible" 
			class="c-breadcrumbs__label" 
			id="breadcrumbs-<?php echo $id ?>">
				{{label}}
		</strong>
		<template v-for="(item, key) in items">
			<span itemprop="itemListElement" itemscope="itemscope" itemtype="http://schema.org/ListItem">
				<router-link v-if="item.isRouterLink" :to="item.url">{{item.name}}</router-link>
				<a v-else class="c-breadcrumbs__link" itemprop="item" :href="item.url"><span itemprop="name">{{item.name}}</span></a>
				<meta itemprop="position" :content="key" />
			</span>
			<span class="c-breadcrumbs__separator"> / </span>
		</template>
	</div>
</template>
<script>
export default {
    name: 'VueBreadcrumbs',
    props: {
        items: {
            type: Object,
            default:  () => {},
		},
		label: {
			type: String,
			default: ''
		},
		isLabelVisible: {
			type: Boolean,
			default: false
		}
	},
}
</script>